import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDividerModule} from '@angular/material/divider';
import {MatTooltipModule} from '@angular/material/tooltip';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { FuseConfirmDialogModule, FuseSidebarModule } from '@fuse/components';

import { GestorStatusComponent } from './gestor-status.component';
import { ProductoComponent } from './producto/producto.component';
import { ListaStatusComponent } from './producto/lista-status/lista-status.component';
import { ListaAdquiridosComponent } from './producto/lista-adquiridos/lista-adquiridos.component';

const rutas: Routes = [
    {
        path     : 'companies/status',
        component: GestorStatusComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'companies/status/certify',
        component: ProductoComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'companies/status/measurement',
        component: ProductoComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'companies/status/pulse',
        component: ProductoComponent,
        canActivate: [AuthGuard]
    },
];

@NgModule({
  declarations: [GestorStatusComponent, ProductoComponent, ListaStatusComponent, ListaAdquiridosComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatTooltipModule,
    TranslateModule,
    FuseConfirmDialogModule,
    FuseSidebarModule,
    RouterModule.forChild(rutas)
  ]
})
export class GestorStatusModule { }
